import React from "react";
import styled from "@emotion/styled";
import ReactPlayer from "react-player/youtube";
// import video from "../../images/video.mp4";

const MastheadBox = styled.div`
  width: auto;
  height: auto;
  /* height: 100vh; */
`;

const MastheadContainer = styled.div`
  position: relative;
  padding-top: 56.25%; // Percentage ratio for 16:9
  position: relative; 
  overflow: hidden;
  > div {
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
  }
`;

// const MastheadVideo = styled.div`
//   position: absolute;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   background-color: black;
//   pointer-events: none;
 
//   > div > video {
//     object-fit: cover;
//   }
// `;

const Masthead = props => {
  const {ytId} = props;
  return (
    <MastheadBox>
      <MastheadContainer>
        <ReactPlayer
          url={"https://www.youtube.com/embed/"+ytId+"?autoplay=1&control=0&rel=0&fs=0"}
          width="100%"
          height="100%"
          playing={true}
          muted
          volume={0}
          playsinline
          loop
          config={{
            file: {
              attributes: {
                poster: ""
              }
            }
          }}
          onReady={() => {
            // console.log("ready");
          }}
          // onDuration={5000}
          onError={err => {
            console.log(err);
          }}
        />
        {/* <MastheadVideo>
          
        </MastheadVideo> */}
      </MastheadContainer>
      
    </MastheadBox>
  );
};

export default Masthead;
